// format locale: en-us -> en-US
export const formatLocale = (locale: string) => {
  const splittedLocale = locale.split('-');
  if (splittedLocale?.[1]) {
    splittedLocale[1] = splittedLocale?.[1]?.toUpperCase();
    return splittedLocale.join('-');
  }
  return locale;
};
